module.exports = __webpack_public_path__ + "static/img/periodo_eleitoral_banner.22b53c2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/periodo_eleitoral_banner.jpeg
// module id = 1612
// module chunks = 1